import { Controller } from 'stimulus'

// Native required/pattern run first (submit does not fire if they fail).
// Rails errors are fetched in-place so the modal never closes.
// Closing/reloading restores the blank form so GET never shows stale errors.
export default class extends Controller {
  connect() {
    this.blankModalContent = this.element.querySelector('.modal-content').outerHTML
  }

  submit(event) {
    const form = event.target
    if (!(form instanceof HTMLFormElement)) {
      return
    }

    if (!form.checkValidity()) {
      form.reportValidity()
      return
    }

    event.preventDefault()
    this.createTranslation(form)
  }

  async createTranslation(form) {
    const response = await fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
    })

    if (response.ok) {
      const data = await response.json()
      window.location.href = data.location
      return
    }

    const html = await response.text()
    this.replaceModalContent(html)
  }

  replaceModalContent(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html')
    const newContent = parsed.querySelector('.modal-content')
    const currentContent = this.element.querySelector('.modal-content')
    if (!newContent || !currentContent) {
      return
    }

    currentContent.replaceWith(newContent)
  }

  reset() {
    const currentContent = this.element.querySelector('.modal-content')
    if (!currentContent || !this.blankModalContent) {
      return
    }

    const wrapper = document.createElement('div')
    wrapper.innerHTML = this.blankModalContent
    currentContent.replaceWith(wrapper.firstElementChild)
  }
}
